import { ReactNode } from "react";

export enum ColumnDataType {
  Text = "text",
  Date = "date"
}

export type DetailCardTitleProperty = {
  id: string;
  parentId?: string;
};

export type TableColumn = {
  id: string;
  type?: ColumnDataType;
  hide?: boolean;
  label: string;
  children?: TableColumn[];
  renderCell?: (data: any, row?: any) => ReactNode;
};

export type SortTableBy = {
  id: string;
  parentId?: string;
};

export type TableDataType = number | Date;

export type TableData = {
  id: string;
};

export enum TableOrder {
  Asc = "asc",
  Desc = "desc"
}

export interface DetailCardField {
  classes?: any;
  id: string;
  label: string;
  group?: string;
  type?: string;
  renderField?: (data: any, row?: any) => ReactNode;
  value: string | number;
}

export type DetailCardAction = {
  label: string;
  shouldDisable?: (data: any) => boolean;
  onClick: (data: any) => void;
};

export type FilterValueTransformFn = (value: string) => string;
